import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex)`
  width: 100%;
  max-width: 1104px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    margin: 0 20px;
  }
`;

export const Section = styled(Flex)`
  padding: 24px;
  background: #fff;
`;

export const SectionTitle = styled.p`
  margin: 8px 0 16px;
  line-height: 28px;
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => props.theme.antd?.colorPrimary};
`;

export const Divider = styled.div`
  height: 4px;
  background-color: #f6f6f6;
`;
